import 'bootstrap';
import $ from 'jquery';
import AOS from 'aos';

import './common/menu';
import './common/navbar';

// Animacja powiększania produktu z CTA przy scrollowaniu

jQuery(function($) {
    var $productImage = $('.product-image-scroll');

    $(window).on('scroll resize', function () {
        var windowHeight = $(window).height();
        var scrollTop = $(window).scrollTop();

        $productImage.each(function () {
            var $el = $(this);
            var offsetTop = $el.offset().top;
            var elHeight = $el.outerHeight();

            
            var elementCenter = offsetTop + elHeight / 2;
            var viewportCenter = scrollTop + windowHeight / 2;

            
            var distance = (elementCenter - viewportCenter) / windowHeight;

            
            var clampedDistance = Math.max(-1, Math.min(1, distance));
            var scale = 1.2 - (clampedDistance + 1) * 0.25; 

            $el.css('transform', 'scale(' + scale.toFixed(3) + ')');
        });
    }).trigger('scroll');
});



jQuery(function($) {
    let scrollBlocked = false;

    const getScrollbarWidth = () => {
        return window.innerWidth - document.documentElement.clientWidth;
    };

    const blockScroll = () => {
        if (scrollBlocked) return;
        scrollBlocked = true;

        const scrollbarWidth = getScrollbarWidth();

        $('html').addClass('noscroll').css('padding-right', scrollbarWidth + 'px');
    };

    const unblockScroll = () => {
        if (!scrollBlocked) return;
        scrollBlocked = false;

        $('html').removeClass('noscroll').css('padding-right', '');
    };

    setInterval(() => {
        const isLightboxOpen = $('.lightboxOverlay').css('display') === 'block';
        if (isLightboxOpen) {
            blockScroll();
        } else {
            unblockScroll();
        }
    }, 100);
});

// Animacja pojawiającego się tekstu (pisania)

jQuery(function($) {
    
    var $typewriterText = $('.typewriter-text');
    var text = $typewriterText.text(); 
    $typewriterText.text(''); 

    var i = 0;
    var speed = 20; 

    
    function typeWriter() {
        if (i < text.length) {
            $typewriterText.append(text.charAt(i)); 
            i++;
            setTimeout(typeWriter, speed); 
        }
    }

    
    AOS.init();
    $(document).ready(function() {
        typeWriter();
    });
});


$(document).ready(() => {
    if ($('#openPopup').length) {
        import('./common/popup')
            .then(module => module.default())
            .catch(err => console.error('Błąd ładowania popupu:', err));
    }

    if ($('.floating-label').length) {
        import('./common/form')
            .then(module => module.default())
            .catch(err => console.error('Błąd ładowania formularzy:', err));
    }

    if ($('#back-to-top').length) {
        import('./common/backToTop')
            .then(module => module.default())
            .catch(err => console.error('Błąd ładowania przycisku powrotu:', err));
    }

    if ($('.home-logos-carousel').length) {
        import('./common/logosCarousel')
            .then(module => module.default())
            .catch(err => console.error('Błąd ładowania przycisku powrotu:', err));
    }

    if ($('.owl-product-offset-carousel').length || $('.product-carousel-on-front').length) {
        import('./common/productCarousel')
            .then(module => module.default())
            .catch(err => console.error('Błąd ładowania przycisku powrotu:', err));
    }
});


AOS.init({
    disable: 'mobile',
    duration: 600, 
});

$(document).ready(() => {
    if ($('.home-video-section').length || $('.home-news-carousel').length || $('.home-logos-carousel').length) {
        import('./pages/home')
            .then(module => module.default())
            .catch(err => console.error('Błąd ładowania modułu HOME:', err));
    }

    if ($('#load-more-news').length || $('#load-more-blog').length) {
        import('./pages/blog')
            .then(module => module.default())
            .catch(err => console.error('Błąd ładowania modułu BLOG:', err));
    }

    if ($('.contact-btn').length || $('.popup-team-member').length) {
        import('./pages/kontakt')
            .then(module => module.default())
            .catch(err => console.error('Błąd ładowania modułu KONTAKT:', err));
    }

    if ($('.owl-product-carousel').length || $('.owl-product-3-carousel').length) {
        import('./pages/produkt')
            .then(module => module.default())
            .catch(err => console.error('Błąd ładowania modułu PRODUKT:', err));
    }

    if ($('.toggle-btn').length || $('select[name="select-225"]').length) {
        import('./pages/kariera')
            .then(module => module.default())
            .catch(err => console.error('Błąd ładowania modułu KARIERA:', err));
    }

    if ($('.file-category-button').length) {
        import('./pages/doPobrania')
            .then(module => module.default())
            .catch(err => console.error('Błąd ładowania modułu DO POBRANIA:', err));
    }
});
